export const namespaces = {
	archive: "archive",
	preview: "preview",
};

export const getNamespace = (archived) =>
	archived ? namespaces.archive : namespaces.preview;
